function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M127 69a64 64 0 11-64 64 64.07 64.07 0 0164-64m0-8a72 72 0 1072 72 72 72 0 00-72-72z",
  fill: "#f44335"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#f44335",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 8,
  d: "M169 82L84 186"
}));

function SvgIconStopCreditRed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 259 259"
  }, props), _ref);
}

export default SvgIconStopCreditRed;